import { iRequest } from '@/utils/requestutil';

export async function save(payload) {
  return iRequest(`/iwms-openapi/api/securityconfig/save`, {
    method: 'POST',
    body: payload,
  });
}

export async function get(payload) {
  return iRequest(
    `/iwms-openapi/api/securityconfig/get?companyUuid=${payload.companyUuid}`,
  );
}